var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCricle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 73,
    viewBox: "0 0 106 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_181_89017)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M103.273 37.7844C103.273 28.128 99.4376 18.8671 92.6101 12.0391C85.7827 5.21098 76.5226 1.375 66.8671 1.375C57.2116 1.375 47.9515 5.21097 41.1241 12.0391C34.2966 18.8671 30.4609 28.128 30.4609 37.7844L66.8671 37.7844L103.273 37.7844Z",
    fill: "url(#paint0_linear_181_89017)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M73 37.5C73 27.8196 69.2072 18.5357 62.4558 11.6906C55.7045 4.84553 46.5478 1 37 1C27.4522 0.999999 18.2955 4.84552 11.5442 11.6906C4.79285 18.5357 1 27.8196 1 37.5L37 37.5L73 37.5Z",
    fill: "url(#paint1_linear_181_89017)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_181_89017)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M0.611818 35.2625C0.611816 44.9189 4.44157 54.1797 11.2586 61.0078C18.0756 67.8359 27.3214 71.6719 36.9622 71.6719C46.6029 71.6719 55.8487 67.8359 62.6657 61.0078C69.4827 54.1797 73.3125 44.9189 73.3125 35.2625L36.9622 35.2625L0.611818 35.2625Z",
    fill: "url(#paint2_linear_181_89017)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M30.4307 35.2508C30.4307 44.9071 34.2798 54.168 41.1314 60.9961C47.983 67.8242 57.2757 71.6601 66.9653 71.6601C76.6549 71.6601 85.9477 67.8242 92.7992 60.9961C99.6508 54.168 103.5 44.9072 103.5 35.2508L66.9653 35.2508L30.4307 35.2508Z",
    fill: "url(#paint3_linear_181_89017)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_181_89017",
    x1: 32.5592,
    y1: -0.996902,
    x2: 109.543,
    y2: 67.1068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6162AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_181_89017",
    x1: 3.07489,
    y1: -1.37781,
    x2: 80.1144,
    y2: 65.8474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6162AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_181_89017",
    x1: 71.2174,
    y1: 74.0438,
    x2: -5.75196,
    y2: 6.05725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6162AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_181_89017",
    x1: 101.394,
    y1: 74.0321,
    x2: 24.3778,
    y2: 5.65896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6162AC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_181_89017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105.774,
    height: 37,
    fill: "white",
    transform: "translate(105.773 37) rotate(180)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_181_89017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104.737,
    height: 36,
    fill: "white",
    transform: "translate(0 37)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCricle);
export default __webpack_public_path__ + "static/media/cricle.60328ff7922fe231813b7e0bb4f914b7.svg";
export { ForwardRef as ReactComponent };